export enum OrganisationSuccessCodes {
  ORGANISATION_SWITCH_SUCCESSFUL = 'org_switch_successful',
}
